import Company from 'interfaces/Company';
import User from 'interfaces/User';
import LogicError from 'shared/classes/LogicError';
import UserContext, {IUserContext, useSafeContext} from './UserContext';

interface ILoggedUserContext extends IUserContext {
  user: User;
  company: Company;
}

export function useCompany(): Company {
  const {company} = useUserContext();
  if (!company) {
    throw new LogicError('Avoid calling useCompany without a company');
  }
  return company;
}

export function useSetCompany(): (company: Company | null) => void {
  const {setCompany} = useUserContext();
  return setCompany;
}

export function useIsLoggedIn(): boolean {
  const {user} = useUserContext();
  return Boolean(user);
}

export function useIsDoctor(): boolean {
  const {isDoctor} = useUserContext();
  return isDoctor;
}

export function useIsPatient(): boolean {
  return !useIsDoctor();
}

export function useUserContext(): IUserContext {
  return useSafeContext(UserContext);
}

export default function useLoggedUserContext(): ILoggedUserContext {
  const value = useSafeContext(UserContext);
  if (value.user === null || value.company === null) {
    throw new Error('Invalid context');
  }

  return value as ILoggedUserContext;
}

export function useLogout(): () => void {
  const {logout} = useUserContext();
  return logout;
}
